import { listProducts, listProductsByMeilisearch } from "@/lib/data/products"
import { getSalesChannels } from "@/lib/data/sales-channes"
import { MeilisearchProductsCarouselContent } from "./MeilisearchProductsCarouselContent"
import { meilisearchFilterBuilder } from "@/lib/meilisearch-utils"
import { Suspense } from "react"

export const MeilisearchProductsCarousel = async ({
  locale,
  seller_handle = process.env.NEXT_PUBLIC_SELLER_HANDLE,
  currency_code,
  category_id,
  showProductCount = 8,
  rows = 1,
  random = false
}: {
  locale: string
  seller_handle?: string
  currency_code: string,
  category_id?: string
  showProductCount?: number
  rows?: number
  random?: boolean
}) => {
  let filter = await meilisearchFilterBuilder({
    locale,
    seller_handle,
    currency_code,
    category_id
  })

  if (!seller_handle) {
    const filters = []
    filters.push("AND")
    const envIgnore = process.env.NEXT_PUBLIC_IGNORE_SELLER_HANDLE;
    if (envIgnore) {
      filters.push(`seller.handle NOT IN ${JSON.stringify(envIgnore.split(","))}`)
    } else {
      filters.push(`seller.handle!=dajianyuncang-store`)
    }
    filter = [filter, ...filters].join(" ")
  }

  let prodRes;
  let meili;
  try {
    meili = await listProductsByMeilisearch({
      query: "",
      filter: filter,
      sort: ["sales:desc"],
      limit: showProductCount,
      offset: 0
    })

    if (meili.estimatedTotalHits > 0) {
      prodRes = await listProducts({
        countryCode: locale,
        queryParams: {
          limit: showProductCount,
          fields:
            "*variants.calculated_price,*seller.reviews,-thumbnail,-images,-type,-tags,-variants.options,-options,-collection,-collection_id",
          //@ts-ignore
          id: meili.hits.map(i => i.id)
        },
      })
    }
  } catch (error) {
    console.error(error)
  }

  return (
    <>
      <MeilisearchProductsCarouselContent
        locale={locale}
        apiProduct={prodRes?.response.products || []}
        meiliProduct={meili?.hits || []}
        rows={rows}
        showProductCount={showProductCount} />
    </>
  )
}